import React, { useContext } from 'react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { useTheme } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import { BereavTableDiv } from '../../components/layout/WrapperDiv';
import { BereavementContext } from '../../context';
import { DateCell } from './CellRenderer';
import {
  expandedWidgetPatientColumnDefs,
  smallWidgetPatientColumnDefs,
} from './TableColumnDef';

interface BereavementTableProps {
  viewModePrint?: boolean;
  smallWidget?: boolean;
}
const frameworkComponents = {
  tableCell: DateCell,
};

export const BereavementTable = ({
  viewModePrint,
  smallWidget,
}: BereavementTableProps) => {
  const {
    props: {
      grid: { rowHeight, headerHeight },
    },
  } = useTheme() as any;

  const { patient, bereavContacts } = useContext(BereavementContext);

  let columnDefs;
  if (patient) {
    columnDefs = smallWidget
      ? smallWidgetPatientColumnDefs
      : expandedWidgetPatientColumnDefs;
  }

  const gridOptions: GridOptions = {
    defaultColDef: {
      resizable: true,
      filter: true,
    },
    columnDefs,
    onGridReady: (params: any) => {
      const gridApi: GridApi = params.api;
      gridApi.sizeColumnsToFit();
      // @strategy for PRINT to work!
      if (gridApi) {
        if (viewModePrint) {
          gridApi.setDomLayout('print');
        }
      }
    },
  };

  return (
    <BereavTableDiv id="bereav-contact">
      <AgGridReact
        gridOptions={gridOptions}
        rowData={bereavContacts || []}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        frameworkComponents={frameworkComponents}
      />
    </BereavTableDiv>
  );
};

export default BereavementTable;
